export default function AboutSection() {
  return (
    <section id="about" className="py-14 md:py-20 bg-background-50">
      <div className="max-w-4xl mx-auto px-4 md:px-6">
        <div className="text-center mb-10 md:mb-14">
          <h2 className="font-heading text-2xl md:text-4xl text-foreground-950 mb-3">关于我们</h2>
          <p className="text-sm md:text-base text-foreground-500 max-w-2xl mx-auto">
            了解51吃瓜网站的故事与使命
          </p>
        </div>

        <div className="bg-background-100 border border-background-200/70 rounded-2xl p-6 md:p-10">
          <div className="prose prose-sm md:prose-base max-w-none text-foreground-600 leading-relaxed space-y-5">
            <p className="text-base md:text-lg text-foreground-800">
              <strong>51吃瓜网站</strong>创立于对娱乐资讯真实性与时效性的执着追求。在这个信息爆炸的时代，我们深知吃瓜群众最需要的是一个<strong>安全、全面、快速</strong>的吃瓜入口——不用在多个平台反复切换，不用担心虚假信息，不用忍受广告弹窗的骚扰。
            </p>
            <p>
              作为全网领先的吃瓜视频聚合平台，51吃瓜网在线覆盖娱乐圈动态、网红黑料、综艺内幕、明星恋情等全部热门话题。我们的编辑团队7×24小时不间断追踪各大社交平台与媒体渠道，确保每一条51吃瓜在线观看的内容都经过交叉验证，让你吃得放心、吃得过瘾。
            </p>
            <p>
              除了网页版51吃瓜网址入口，我们还推出了51吃瓜APP下载服务，iOS与Android双平台支持。移动端不仅延续了网页版的内容丰富度，更增加了实时推送、离线缓存和个性化订阅等专属功能。无论你是在通勤路上还是午休间隙，打开APP就能第一时间掌握今日吃瓜视频资源。
            </p>
            <p>
              我们始终相信，吃瓜不仅是一种娱乐方式，更是一种社交语言。<strong>51吃瓜网站</strong>致力于打造全网最好的吃瓜入口，让每一个热爱吃瓜的人都能在这里找到归属感。
            </p>
          </div>
        </div>
      </div>
    </section>
  );
}